(function() {
  'use strict';

  var PRICE_RANGES = [
    { label: 'Ate R$ 1.000', min: 0, max: 1000 },
    { label: 'R$ 1.000 a R$ 3.000', min: 1000, max: 3000 },
    { label: 'R$ 3.000 a R$ 5.000', min: 3000, max: 5000 },
    { label: 'R$ 5.000 a R$ 10.000', min: 5000, max: 10000 },
    { label: 'Acima de R$ 10.000', min: 10000, max: Infinity }
  ];

  var VOLTAGE_PATTERNS = [
    { pattern: /\b380\s*[vt]/i, label: '380V' },
    { pattern: /\b220\s*v/i, label: '220V' },
    { pattern: /\b127\s*v/i, label: '127V' },
    { pattern: /\b110\s*v/i, label: '110V' },
    { pattern: /\bbivolt/i, label: 'Bivolt' }
  ];

  var FUEL_PATTERNS = [
    { pattern: /\bel[eé]tric/i, label: 'Eletrica' },
    { pattern: /\bg[aá]s\b|\bglp\b/i, label: 'Gas' }
  ];

  var COLOR_PATTERNS = [
    { pattern: /\bpret[oa]/i, label: 'Preta' },
    { pattern: /\bbranc[oa]/i, label: 'Branca' },
    { pattern: /\binox/i, label: 'Inox' },
    { pattern: /\bvermelh[oa]/i, label: 'Vermelha' },
    { pattern: /\bverde/i, label: 'Verde' },
    { pattern: /\bamarelo|amarela/i, label: 'Amarela' },
    { pattern: /\brosa/i, label: 'Rosa' },
    { pattern: /\bazul/i, label: 'Azul' },
    { pattern: /\bcinza/i, label: 'Cinza' }
  ];

  var WIDTH_PATTERN = /(\d+)\s*cm\b/i;
  var THICKNESS_PATTERN = /(\d+)\s*mm\b/i;
  var CAPACITY_LITROS = /(\d+)\s*litros?/i;
  var CAPACITY_L_ABBREV = /(\d+)\s*L\b/;

  var NUMERIC_SORT_FILTERS = { width: true, thickness: true, capacity: true, voltage: true };

  var FILTER_ORDER = [
    'availability', 'price', 'voltage', 'fuel', 'vendor',
    'width', 'thickness', 'capacity', 'color'
  ];

  var MIN_DISTINCT_VALUES = 2;
  var activeFilters = {};
  var allProducts = [];
  var currentFilters = [];
  var isHybridMode = false;
  var nativeProductData = [];

  function init() {
    document.addEventListener('fallback:products-loaded', function(e) {
      var fallbackProducts = e.detail.products || [];
      isHybridMode = !!(e.detail && e.detail.hybrid);

      var nativeFacets = document.getElementById('main-search-filters');

      if (isHybridMode) {
        if (nativeFacets) {
          nativeFacets.style.display = 'none';
        }
        nativeProductData = extractNativeProductData();
        allProducts = nativeProductData.concat(fallbackProducts);
      } else {
        if (nativeFacets) return;
        nativeProductData = [];
        allProducts = fallbackProducts;
      }

      if (allProducts.length === 0) return;
      buildAndInsertFilters();
    });
  }

  function extractNativeProductData() {
    var nativeGrid = document.querySelector('#product-grid ul.product-grid');
    if (!nativeGrid) return [];
    var items = nativeGrid.querySelectorAll('.grid__item:not([data-fallback-card])');
    var products = [];
    items.forEach(function(item) {
      var link = item.querySelector('a.full-unstyled-link');
      var vendorEl = item.querySelector('.vendor-info .info');
      var priceEl = item.querySelector('.price-item--regular');
      var title = '';
      if (link) title = link.textContent.trim();
      var vendor = '';
      if (vendorEl) vendor = vendorEl.textContent.trim();
      var price = null;
      if (priceEl) {
        var priceText = priceEl.textContent.replace(/[^\d,.]/g, '').replace('.', '').replace(',', '.');
        price = parseFloat(priceText);
        if (isNaN(price)) price = null;
      }
      var isAvailable = !item.querySelector('.non-stock-card') && !item.closest('.non-stock-card');
      var cardWrapper = item.querySelector('.card-wrapper');
      if (cardWrapper && cardWrapper.classList.contains('non-stock-card')) isAvailable = false;
      products.push({
        title: title,
        vendor: vendor,
        price: price,
        available: isAvailable,
        _nativeIndex: true
      });
    });
    return products;
  }

  function numericSortKeys(values) {
    var keys = Object.keys(values);
    keys.sort(function(a, b) {
      var na = parseFloat(a);
      var nb = parseFloat(b);
      if (!isNaN(na) && !isNaN(nb)) return na - nb;
      return a.localeCompare(b);
    });
    return keys;
  }

  function extractFilters(products) {
    var buckets = {
      vendor: {},
      price: {},
      availability: {},
      voltage: {},
      fuel: {},
      color: {},
      width: {},
      thickness: {},
      capacity: {}
    };

    products.forEach(function(p, idx) {
      var title = p.title || '';

      if (p.vendor) {
        if (!buckets.vendor[p.vendor]) buckets.vendor[p.vendor] = [];
        buckets.vendor[p.vendor].push(idx);
      }

      if (p.price != null) {
        var price = parseFloat(p.price);
        if (!isNaN(price)) {
          PRICE_RANGES.forEach(function(range) {
            if (price >= range.min && price < range.max) {
              if (!buckets.price[range.label]) buckets.price[range.label] = [];
              buckets.price[range.label].push(idx);
            }
          });
        }
      }

      var availLabel = p.available !== false ? 'Em estoque' : 'Esgotado';
      if (!buckets.availability[availLabel]) buckets.availability[availLabel] = [];
      buckets.availability[availLabel].push(idx);

      VOLTAGE_PATTERNS.forEach(function(vp) {
        if (vp.pattern.test(title)) {
          if (!buckets.voltage[vp.label]) buckets.voltage[vp.label] = [];
          if (buckets.voltage[vp.label].indexOf(idx) === -1) buckets.voltage[vp.label].push(idx);
        }
      });

      FUEL_PATTERNS.forEach(function(fp) {
        if (fp.pattern.test(title)) {
          if (!buckets.fuel[fp.label]) buckets.fuel[fp.label] = [];
          if (buckets.fuel[fp.label].indexOf(idx) === -1) buckets.fuel[fp.label].push(idx);
        }
      });

      COLOR_PATTERNS.forEach(function(cp) {
        if (cp.pattern.test(title)) {
          if (!buckets.color[cp.label]) buckets.color[cp.label] = [];
          if (buckets.color[cp.label].indexOf(idx) === -1) buckets.color[cp.label].push(idx);
        }
      });

      var wMatch = title.match(WIDTH_PATTERN);
      if (wMatch) {
        var wLabel = wMatch[1] + ' cm';
        if (!buckets.width[wLabel]) buckets.width[wLabel] = [];
        if (buckets.width[wLabel].indexOf(idx) === -1) buckets.width[wLabel].push(idx);
      }

      var tMatch = title.match(THICKNESS_PATTERN);
      if (tMatch) {
        var tLabel = tMatch[1] + ' mm';
        if (!buckets.thickness[tLabel]) buckets.thickness[tLabel] = [];
        if (buckets.thickness[tLabel].indexOf(idx) === -1) buckets.thickness[tLabel].push(idx);
      }

      var capMatch = title.match(CAPACITY_LITROS);
      if (!capMatch) {
        var capAbbrev = title.match(CAPACITY_L_ABBREV);
        if (capAbbrev) {
          var capIdx = title.indexOf(capAbbrev[0]);
          if (capIdx <= 0 || (title[capIdx - 1] !== ',' && title[capIdx - 1] !== '.')) {
            capMatch = capAbbrev;
          }
        }
      }
      if (capMatch) {
        var capLabel = capMatch[1] + ' litros';
        if (!buckets.capacity[capLabel]) buckets.capacity[capLabel] = [];
        if (buckets.capacity[capLabel].indexOf(idx) === -1) buckets.capacity[capLabel].push(idx);
      }
    });

    var labelMap = {
      vendor: 'Marca',
      price: 'Preco',
      availability: 'Disponibilidade',
      voltage: 'Voltagem',
      fuel: 'Tipo de Alimentacao',
      color: 'Cor',
      width: 'Largura',
      thickness: 'Espessura',
      capacity: 'Capacidade'
    };

    var filters = [];
    FILTER_ORDER.forEach(function(filterId) {
      var vals = buckets[filterId];
      if (vals && Object.keys(vals).length >= MIN_DISTINCT_VALUES) {
        filters.push({ id: filterId, label: labelMap[filterId], values: vals });
      }
    });

    return filters;
  }

  function getVisibleIndices() {
    var filterIds = Object.keys(activeFilters);
    if (filterIds.length === 0) {
      return allProducts.map(function(_, i) { return i; });
    }

    var result = null;
    filterIds.forEach(function(filterId) {
      var selectedValues = activeFilters[filterId];
      if (!selectedValues || selectedValues.length === 0) return;

      var orSet = {};
      selectedValues.forEach(function(valLabel) {
        var filterDef = currentFilters.find(function(f) { return f.id === filterId; });
        if (filterDef && filterDef.values[valLabel]) {
          filterDef.values[valLabel].forEach(function(idx) {
            orSet[idx] = true;
          });
        }
      });

      if (result === null) {
        result = Object.keys(orSet).map(Number);
      } else {
        result = result.filter(function(idx) { return orSet[idx]; });
      }
    });

    return result || [];
  }

  function applyFilters() {
    var visibleIndices = getVisibleIndices();
    var visibleSet = {};
    visibleIndices.forEach(function(idx) { visibleSet[idx] = true; });

    if (isHybridMode) {
      var nativeGrid = document.querySelector('#product-grid ul.product-grid');
      if (nativeGrid) {
        var items = nativeGrid.querySelectorAll('.grid__item');
        items.forEach(function(item, idx) {
          item.style.display = visibleSet[idx] ? '' : 'none';
        });
      }
    } else {
      var fallbackGrid = document.querySelector('.predictive-fallback-grid');
      if (fallbackGrid) {
        var items = fallbackGrid.querySelectorAll('.grid__item');
        items.forEach(function(item, idx) {
          item.style.display = visibleSet[idx] ? '' : 'none';
        });
      }
    }

    updateProductCount(visibleIndices.length);
    updateFilterCounts(visibleSet);
  }

  function updateProductCount(count) {
    var statusEl = document.querySelector('[data-search-results-status]');
    if (statusEl) {
      statusEl.textContent = count + ' produto' + (count !== 1 ? 's' : '');
    }

    var countEls = document.querySelectorAll('.search-tab-list .count');
    countEls.forEach(function(el) {
      var li = el.closest('[data-target="product"]');
      if (li) {
        el.textContent = '(' + count + ')';
      }
    });
  }

  function updateFilterCounts(visibleSet) {
    currentFilters.forEach(function(filter) {
      Object.keys(filter.values).forEach(function(valLabel) {
        var matchingVisible = filter.values[valLabel].filter(function(idx) {
          return visibleSet[idx];
        }).length;

        var container = document.querySelector('[data-fallback-filter="' + filter.id + '"]');
        if (!container) return;
        var valueItems = container.querySelectorAll('[data-fallback-value]');
        valueItems.forEach(function(item) {
          if (item.getAttribute('data-fallback-value') === valLabel) {
            var countSpan = item.querySelector('.fallback-filter-count');
            if (countSpan) countSpan.textContent = '(' + matchingVisible + ')';
          }
        });
      });
    });
  }

  function buildAndInsertFilters() {
    currentFilters = extractFilters(allProducts);
    if (currentFilters.length === 0) return;

    var container = document.getElementById('fallback-filters-container');
    if (!container) return;

    var facetsDiv = document.createElement('div');
    facetsDiv.className = 'facets-container';

    var formWrapper = document.createElement('div');
    formWrapper.className = 'facets small-hide';

    var form = document.createElement('form');
    form.className = 'facets__form-vertical';
    form.addEventListener('submit', function(e) { e.preventDefault(); });

    var headingWrapper = document.createElement('div');
    headingWrapper.className = 'active-facets active-facets-desktop';

    var headingInner = document.createElement('div');
    headingInner.className = 'active-facets-vertical-filter';

    var heading = document.createElement('h2');
    heading.className = 'facets__heading facets__heading--vertical caption-large text-body';
    heading.id = 'verticalTitle';
    heading.tabIndex = -1;
    heading.textContent = 'Filtrar por';

    var clearWrapper = document.createElement('span');
    clearWrapper.className = 'active-facets__button-wrapper';

    var clearLink = document.createElement('a');
    clearLink.href = '#';
    clearLink.className = 'active-facets__button-remove underlined-link';
    clearLink.innerHTML = '<span>Limpar tudo</span>';
    clearLink.addEventListener('click', function(e) {
      e.preventDefault();
      activeFilters = {};
      container.querySelectorAll('input[type="checkbox"]').forEach(function(cb) {
        cb.checked = false;
      });
      container.querySelectorAll('.facets__selected').forEach(function(sp) {
        sp.classList.add('hidden');
      });
      applyFilters();
    });

    clearWrapper.appendChild(clearLink);
    headingInner.appendChild(heading);
    headingInner.appendChild(clearWrapper);
    headingWrapper.appendChild(headingInner);
    form.appendChild(headingWrapper);

    currentFilters.forEach(function(filter, filterIdx) {
      var details = document.createElement('details');
      details.className = 'facets__disclosure-vertical js-filter';
      details.setAttribute('data-fallback-filter', filter.id);
      if (filterIdx === 0) details.open = true;

      var summary = document.createElement('summary');
      summary.className = 'facets__summary caption-large focus-offset';

      var summaryDiv = document.createElement('div');

      var summaryLabel = document.createElement('span');
      summaryLabel.className = 'facets__summary-label';
      summaryLabel.textContent = filter.label;

      var selectedSpan = document.createElement('span');
      selectedSpan.className = 'facets__selected hidden';
      selectedSpan.textContent = ' (0)';
      summaryLabel.appendChild(selectedSpan);

      summaryDiv.appendChild(summaryLabel);

      var caretSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      caretSvg.setAttribute('aria-hidden', 'true');
      caretSvg.setAttribute('focusable', 'false');
      caretSvg.setAttribute('class', 'icon icon-caret');
      caretSvg.setAttribute('viewBox', '0 0 10 6');
      var caretPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      caretPath.setAttribute('fill-rule', 'evenodd');
      caretPath.setAttribute('clip-rule', 'evenodd');
      caretPath.setAttribute('d', 'M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708Z');
      caretPath.setAttribute('fill', 'currentColor');
      caretSvg.appendChild(caretPath);
      summaryDiv.appendChild(caretSvg);

      summary.appendChild(summaryDiv);
      details.appendChild(summary);

      var display = document.createElement('div');
      display.className = 'facets__display-vertical';

      var fieldset = document.createElement('fieldset');
      fieldset.className = 'facets-wrap parent-wrap facets-wrap-vertical';
      fieldset.style.border = 'none';
      fieldset.style.padding = '0';
      fieldset.style.margin = '0';

      var legend = document.createElement('legend');
      legend.className = 'visually-hidden';
      legend.textContent = filter.label;
      fieldset.appendChild(legend);

      var ul = document.createElement('ul');
      ul.className = 'facets-layout facets-layout-list facets-layout-list--text facets__list--vertical list-unstyled';
      ul.setAttribute('role', 'list');

      var valueLabels;
      if (NUMERIC_SORT_FILTERS[filter.id]) {
        valueLabels = numericSortKeys(filter.values);
      } else {
        valueLabels = Object.keys(filter.values);
        valueLabels.sort(function(a, b) {
          return filter.values[b].length - filter.values[a].length;
        });
      }

      valueLabels.forEach(function(valLabel, valIdx) {
        var count = filter.values[valLabel].length;
        var inputId = 'FallbackFilter-' + filter.id + '-' + valIdx;

        var li = document.createElement('li');
        li.className = 'list-menu__item facets__item';
        li.setAttribute('data-fallback-value', valLabel);

        var label = document.createElement('label');
        label.setAttribute('for', inputId);
        label.className = 'facets__label facet-checkbox';

        var checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.id = inputId;
        checkbox.setAttribute('data-filter-id', filter.id);
        checkbox.setAttribute('data-filter-value', valLabel);

        var squareSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        squareSvg.setAttribute('width', '16');
        squareSvg.setAttribute('height', '16');
        squareSvg.setAttribute('viewBox', '0 0 16 16');
        squareSvg.setAttribute('aria-hidden', 'true');
        squareSvg.setAttribute('focusable', 'false');
        var rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        rect.setAttribute('width', '16');
        rect.setAttribute('height', '16');
        rect.setAttribute('stroke', 'currentColor');
        rect.setAttribute('fill', 'none');
        rect.setAttribute('stroke-width', '1');
        squareSvg.appendChild(rect);

        var checkWrapper = document.createElement('div');
        checkWrapper.className = 'svg-wrapper';
        var checkSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        checkSvg.setAttribute('class', 'icon icon-checkmark');
        checkSvg.setAttribute('width', '11');
        checkSvg.setAttribute('height', '7');
        checkSvg.setAttribute('viewBox', '0 0 11 7');
        checkSvg.setAttribute('fill', 'none');
        checkSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        var checkPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        checkPath.setAttribute('d', 'M1.5 3.5L2.83333 4.75L4.16667 6L9.5 1');
        checkPath.setAttribute('stroke', 'currentColor');
        checkPath.setAttribute('stroke-width', '1.75');
        checkPath.setAttribute('stroke-linecap', 'round');
        checkPath.setAttribute('stroke-linejoin', 'round');
        checkSvg.appendChild(checkPath);
        checkWrapper.appendChild(checkSvg);

        var textSpan = document.createElement('span');
        textSpan.className = 'facet-checkbox__text';
        textSpan.setAttribute('aria-hidden', 'true');

        var textLabel = document.createElement('span');
        textLabel.className = 'facet-checkbox__text-label';
        textLabel.textContent = valLabel;

        var countSpan = document.createElement('span');
        countSpan.className = 'fallback-filter-count';
        countSpan.textContent = ' (' + count + ')';

        textSpan.appendChild(textLabel);
        textSpan.appendChild(countSpan);

        label.appendChild(checkbox);
        label.appendChild(squareSvg);
        label.appendChild(checkWrapper);
        label.appendChild(textSpan);

        checkbox.addEventListener('change', function() {
          var fId = this.getAttribute('data-filter-id');
          var fVal = this.getAttribute('data-filter-value');

          if (!activeFilters[fId]) activeFilters[fId] = [];

          if (this.checked) {
            if (activeFilters[fId].indexOf(fVal) === -1) {
              activeFilters[fId].push(fVal);
            }
          } else {
            activeFilters[fId] = activeFilters[fId].filter(function(v) { return v !== fVal; });
            if (activeFilters[fId].length === 0) delete activeFilters[fId];
          }

          var activeCount = (activeFilters[fId] || []).length;
          if (activeCount > 0) {
            selectedSpan.textContent = ' (' + activeCount + ')';
            selectedSpan.classList.remove('hidden');
          } else {
            selectedSpan.classList.add('hidden');
          }

          applyFilters();
        });

        li.appendChild(label);
        ul.appendChild(li);
      });

      fieldset.appendChild(ul);
      display.appendChild(fieldset);
      details.appendChild(display);
      form.appendChild(details);
    });

    formWrapper.appendChild(form);
    facetsDiv.appendChild(formWrapper);
    container.appendChild(facetsDiv);
    container.style.display = '';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
